import { Placement } from 'api/placement/types'

export const placements: Placement[] = [
  {
    application: {
      id: '1',
    },
    createdAt: '2021-12-07T22:55:13Z',
    id: '1',
    isDefault: true,
    mobileBannerUrl: '',
    name: 'Default',
    colors: {
      tagColor: '#251546',
      buttonColor: '#DA1A42',
      buttonTextColor: '#FFFFFF',
    },
    status: 'enabled',
    tabsEnabled: false,
    turboEnabled: false,
    webOfwEnabled: false,
    tabletBannerUrl: '',
    updatedAt: '2022-01-28T18:02:39Z',
    virtualCurrency: {
      id: '1',
    },
    virtualCurrencySaleEnabled: false,
    virtualCurrencySaleRewardMultiplier: 1,
    exchangeRates: [
      {
        rate: 1.5,
        countries: ['WW'],
      },
      {
        rate: 3,
        countries: ['TR', 'FR', 'AL'],
      },
    ],
  },
  {
    application: {
      id: '1',
    },
    createdAt: '2021-12-07T22:55:13Z',
    id: '2',
    isDefault: false,
    mobileBannerUrl:
      'https://ofw-assets-stg.s3.eu-west-1.amazonaws.com/opd/placement_mobile_banner/308599f4-476a-4038-bf50-66398d16fa4b.jpeg',
    name: "King's place",
    colors: {
      tagColor: '#251546',
      buttonColor: '#DA1A42',
      buttonTextColor: '#FFFFFF',
    },
    status: 'enabled',
    tabsEnabled: false,
    turboEnabled: true,
    webOfwEnabled: true,
    tabletBannerUrl: '',
    updatedAt: '2022-01-28T18:02:39Z',
    virtualCurrency: {
      id: '1',
    },
    virtualCurrencySaleEnabled: false,
    virtualCurrencySaleRewardMultiplier: 1,
    exchangeRates: [
      {
        rate: 1.5,
        countries: ['WW'],
        id: '1',
      },
      {
        rate: 2,
        countries: ['RO', 'TR'],
        id: '2',
      },
    ],
  },
  {
    application: {
      id: '2',
    },
    createdAt: '2021-12-07T22:55:13Z',
    id: '3',
    isDefault: true,
    mobileBannerUrl: '',
    name: 'Default',
    colors: {
      tagColor: '#251546',
      buttonColor: '#DA1A42',
      buttonTextColor: '#FFFFFF',
    },
    status: 'enabled',
    tabsEnabled: true,
    turboEnabled: false,
    webOfwEnabled: false,
    tabletBannerUrl: '',
    updatedAt: '2022-01-28T18:02:39Z',
    virtualCurrency: {
      id: '2',
    },
    virtualCurrencySaleEnabled: false,
    virtualCurrencySaleRewardMultiplier: 1,
    exchangeRates: [
      {
        rate: 1.5,
        countries: ['WW'],
      },
      {
        rate: 3,
        countries: ['TR', 'FR', 'AL'],
      },
    ],
  },
  {
    application: {
      id: '2',
    },
    createdAt: '2021-12-07T22:55:13Z',
    id: '4',
    isDefault: false,
    mobileBannerUrl: '',
    name: "Queen's place",
    colors: {
      tagColor: '#251546',
      buttonColor: '#DA1A42',
      buttonTextColor: '#FFFFFF',
    },
    status: 'enabled',
    tabsEnabled: false,
    turboEnabled: false,
    webOfwEnabled: false,
    tabletBannerUrl: '',
    updatedAt: '2022-01-28T18:02:39Z',
    virtualCurrency: {
      id: '2',
    },
    virtualCurrencySaleEnabled: false,
    virtualCurrencySaleRewardMultiplier: 1,
    exchangeRates: [
      {
        rate: 1.5,
        countries: ['WW'],
      },
      {
        rate: 3,
        countries: ['TR', 'FR', 'AL'],
      },
    ],
  },
]
